import './zod-setup';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppProviders } from '@/app/providers/app-providers';
import { createAppRouter } from '@/app/router';
import { createAppRuntime } from '@/app/runtime';
import '@batiflow/ui/fonts/latin.css';
import './index.css';

const runtime = createAppRuntime();
const router = createAppRouter();

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

createRoot(container).render(
  <StrictMode>
    <AppProviders runtime={runtime}>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
